import { watch, ref, reactive, Ref } from "vue";
import ChartsApiService, {
  AttentionEventEx,
  EmotionsEventEx,
  ParticipantEx,
  ParticipationEventEx,
} from "@/services/ChartsApiService";

import utils from "@/system/utils";
import { Session } from "@/services/typescript-fetch-client-generated";

const mainStore = {
  sessions: ref(reactive([])) as Ref<Session[]>,
  sessionsAreLoadings: ref(false) as Ref<any>,
  sessionDataIsLoading: ref(false) as Ref<any>,

  selectedSession: ref() as Ref</*Session*/ number>,
  currentSession: ref() as Ref<Session>,
  sessionParticipants: ref([]) as Ref<ParticipantEx[]>,
  sessionAttentions: ref([]) as Ref<AttentionEventEx[]>,
  sessionParticipations: ref([]) as Ref<ParticipationEventEx[]>,
  sessionEmotions: ref([]) as Ref<EmotionsEventEx[]>,

  switchParticipantSelection: (id: number) => {
    let participant: any = mainStore.sessionParticipants.value.find(
      (p) => p.participantId === id
    );
    if (participant) {
      participant.show = !participant.show;
    }
  },

  init: async () => {
    await getSessions();

    watch(
      () => mainStore.selectedSession.value,
      async (current, prev) => {
        console.log("selectedSessionSwitched", prev, current);

        const matchedSession = mainStore.sessions.value.find(
          (c) => c.sessionId === current
        );
        if (!matchedSession) return;

        mainStore.currentSession.value = matchedSession;

        mainStore.sessionDataIsLoading.value = true;

        let data = await ChartsApiService.getSessionData(current);

        mainStore.sessionAttentions.value = data.attentions;
        mainStore.sessionParticipants.value = data.participants;
        mainStore.sessionParticipations.value = data.participations;
        mainStore.sessionEmotions.value = data.emotions.map(
          (value) => value as unknown as EmotionsEventEx
        );

        for (let participant of data.participants) participant.show = true;
        for (let participation of data.participations)
          participation.ts = new Date(participation.timestamp).getTime() / 1000;
        for (let attention of data.attentions)
          attention.ts = new Date(attention.timestamp).getTime() / 1000;
        for (let emotion of data.emotions)
          emotion.ts = new Date(emotion.timestamp).getTime() / 1000;

        mainStore.sessionDataIsLoading.value = false;
      }
    );
  },
};

async function getSessions() {
  mainStore.sessionsAreLoadings.value = true;
  mainStore.sessions.value = await ChartsApiService.getAllSessions();
  mainStore.sessionsAreLoadings.value = false;
}

export { mainStore };
